(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fc-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ANIM_SELECTOR = '[data-fc-anim]';
    var ROOT_SELECTOR = '[data-fc-footer]';
    var DESKTOP_QUERY = '(min-width: 1024px)';
    var EMAIL_PATTERN = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
    var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
    var KLAVIYO_REVISION = '2024-10-15';

    function toArray(list) {
      return Array.prototype.slice.call(list);
    }

    function prefersReduced() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    /* Shared Full Cart premium reveal */
    function initFcAnim(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var elements = scope.querySelectorAll(ANIM_SELECTOR);
      if (!elements.length) return;

      var observer = null;
      if (!prefersReduced() && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('fc-anim--in');
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
        );
      }

      Array.prototype.forEach.call(elements, function (el) {
        if (el.dataset.fcAnimReady === 'true') return;
        el.dataset.fcAnimReady = 'true';

        if (!observer) {
          el.classList.add('fc-anim--in');
          return;
        }

        observer.observe(el);
      });
    }

    /* --- Collapsible menu columns (mobile only) --- */
    function setupMenus(root) {
      var menus = toArray(root.querySelectorAll('[data-fc-footer-menu]'));
      if (!menus.length) return;

      var desktop = window.matchMedia ? window.matchMedia(DESKTOP_QUERY) : null;

      function isDesktop() {
        return desktop ? desktop.matches : false;
      }

      /* Desktop keeps every column open and the toggle out of the layout; mobile starts closed */
      function sync() {
        var onDesktop = isDesktop();

        menus.forEach(function (menu) {
          var toggle = menu.querySelector('[data-fc-footer-toggle]');
          if (!toggle) return;

          if (onDesktop) {
            menu.classList.remove('is-collapsible', 'is-open');
            toggle.setAttribute('aria-expanded', 'true');
            return;
          }

          menu.classList.add('is-collapsible');
          toggle.setAttribute('aria-expanded', menu.classList.contains('is-open') ? 'true' : 'false');
        });
      }

      menus.forEach(function (menu) {
        var toggle = menu.querySelector('[data-fc-footer-toggle]');
        if (!toggle) return;

        toggle.addEventListener('click', function () {
          if (isDesktop()) return;

          var willOpen = !menu.classList.contains('is-open');
          menu.classList.toggle('is-open', willOpen);
          toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
      });

      sync();

      if (desktop) {
        if (typeof desktop.addEventListener === 'function') {
          desktop.addEventListener('change', sync);
        } else if (typeof desktop.addListener === 'function') {
          desktop.addListener(sync);
        }
      }
    }

    /* --- Country selector submits on change; the noscript button covers the rest --- */
    function setupCountry(root) {
      var select = root.querySelector('[data-fc-footer-country]');
      if (!select || !select.form) return;

      select.addEventListener('change', function () {
        select.form.submit();
      });
    }

    /* --- Klaviyo newsletter signup (progressive enhancement over the Shopify form) --- */
    function setupKlaviyo(root) {
      var wrap = root.querySelector('[data-fc-footer-klaviyo]');
      if (!wrap) return;

      var form = wrap.querySelector('form');
      if (!form) return;

      var input = form.querySelector('[data-fc-footer-email]');
      var button = form.querySelector('.fc-footer__submit');
      var status = form.querySelector('[data-fc-footer-status]');
      var companyId = wrap.dataset.companyId;
      var listId = wrap.dataset.listId;

      function setStatus(message, isError) {
        if (!status) return;
        status.textContent = message || '';
        status.classList.toggle('is-error', !!isError);
      }

      function setBusy(busy) {
        if (!button) return;
        button.setAttribute('aria-busy', busy ? 'true' : 'false');
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var email = input ? input.value.trim() : '';

        if (!EMAIL_PATTERN.test(email)) {
          setStatus(wrap.dataset.invalid, true);
          if (input) input.focus();
          return;
        }

        setStatus('', false);
        setBusy(true);

        fetch(KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: KLAVIYO_REVISION
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: email }
                  }
                }
              },
              relationships: {
                list: {
                  data: { type: 'list', id: listId }
                }
              }
            }
          })
        })
          .then(function (response) {
            if (response.ok) {
              setStatus(wrap.dataset.success, false);
              form.reset();
              return;
            }
            setStatus(wrap.dataset.error, true);
          })
          .catch(function () {
            setStatus(wrap.dataset.error, true);
          })
          .then(function () {
            setBusy(false);
          });
      });
    }

    function setupComponent(root) {
      setupMenus(root);
      setupCountry(root);
      setupKlaviyo(root);
    }

    function initFcFooter(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var roots = scope.querySelectorAll(ROOT_SELECTOR);

      Array.prototype.forEach.call(roots, function (el) {
        if (el.dataset.fcFooterReady === 'true') return;
        el.dataset.fcFooterReady = 'true';
        setupComponent(el);
      });
    }

    function init(root) {
      initFcAnim(root);
      initFcFooter(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ANIM_SELECTOR = '[data-fc-anim]';
    var ROOT_SELECTOR = '[data-fc-faq]';

    function prefersReduced() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function toArray(list) {
      return Array.prototype.slice.call(list);
    }

    /* Shared Full Cart premium reveal */
    function initFcAnim(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var elements = scope.querySelectorAll(ANIM_SELECTOR);
      if (!elements.length) return;

      var observer = null;
      if (!prefersReduced() && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('fc-anim--in');
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
        );
      }

      Array.prototype.forEach.call(elements, function (el) {
        if (el.dataset.fcAnimReady === 'true') return;
        el.dataset.fcAnimReady = 'true';

        if (!observer) {
          el.classList.add('fc-anim--in');
          return;
        }

        observer.observe(el);
      });
    }

    function setupComponent(root) {
      var items = toArray(root.querySelectorAll('[data-fc-faq-item]'));
      if (!items.length) return;

      function setOpen(item, isOpen) {
        var toggle = item.querySelector('[data-fc-faq-toggle]');
        if (!toggle || toggle.disabled) return;

        item.classList.toggle('is-open', isOpen);
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }

      /* Only one row is open at a time — the open row closes before the next opens */
      items.forEach(function (item) {
        var toggle = item.querySelector('[data-fc-faq-toggle]');
        if (!toggle || toggle.disabled) return;

        toggle.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');

          items.forEach(function (other) {
            setOpen(other, willOpen && other === item);
          });
        });
      });
    }

    function initFcFaq(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var roots = scope.querySelectorAll(ROOT_SELECTOR);

      Array.prototype.forEach.call(roots, function (el) {
        if (el.dataset.fcFaqReady === 'true') return;
        el.dataset.fcFaqReady = 'true';
        setupComponent(el);
      });
    }

    function init(root) {
      initFcAnim(root);
      initFcFaq(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-quiz-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ANIM_SELECTOR = '[data-fc-anim]';
    var ROOT_SELECTOR = '.fc-quiz-banner';

    function prefersReduced() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    /* Shared Full Cart premium reveal */
    function initFcAnim(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var elements = scope.querySelectorAll(ANIM_SELECTOR);
      if (!elements.length) return;

      var observer = null;
      if (!prefersReduced() && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('fc-anim--in');
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
        );
      }

      Array.prototype.forEach.call(elements, function (el) {
        if (el.dataset.fcAnimReady === 'true') return;
        el.dataset.fcAnimReady = 'true';

        if (!observer) {
          el.classList.add('fc-anim--in');
          return;
        }

        observer.observe(el);
      });
    }

    function init(scope) {
      var context = scope && scope.querySelectorAll ? scope : document;
      var roots = context.querySelectorAll(ROOT_SELECTOR);
      if (!roots.length) return;

      Array.prototype.forEach.call(roots, function (root) {
        initFcAnim(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    /* The theme editor swaps the section node out, so re-bind on reload */
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '[data-fc-anim]';

    function reveal(el) {
      el.classList.add('fc-anim--in');
    }

    function initFcAnim(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var elements = scope.querySelectorAll(SELECTOR);
      if (!elements.length) return;

      var prefersReduced =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var observer = null;
      if (!prefersReduced && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                reveal(entry.target);
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
        );
      }

      Array.prototype.forEach.call(elements, function (el) {
        if (el.dataset.fcAnimReady === 'true') return;
        el.dataset.fcAnimReady = 'true';

        if (!observer) {
          reveal(el);
          return;
        }

        observer.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initFcAnim(document);
      });
    } else {
      initFcAnim(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initFcAnim(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-review-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ANIM_SELECTOR = '[data-fc-anim]';
    var ROOT_SELECTOR = '[data-fc-review-carousel]';
    var CIRCUMFERENCE = 56.549; /* 2 * PI * r, r = 9 */

    function prefersReduced() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function toArray(list) {
      return Array.prototype.slice.call(list);
    }

    /* Shared Full Cart premium reveal */
    function initFcAnim(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var elements = scope.querySelectorAll(ANIM_SELECTOR);
      if (!elements.length) return;

      var observer = null;
      if (!prefersReduced() && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('fc-anim--in');
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
        );
      }

      Array.prototype.forEach.call(elements, function (el) {
        if (el.dataset.fcAnimReady === 'true') return;
        el.dataset.fcAnimReady = 'true';

        if (!observer) {
          el.classList.add('fc-anim--in');
          return;
        }

        observer.observe(el);
      });
    }

    function setupCarousel(root) {
      var track = root.querySelector('[data-fc-review-track]');
      var cards = toArray(root.querySelectorAll('[data-fc-review-card]'));
      if (!track || !cards.length) return;

      var heading = root.querySelector('[data-fc-review-heading]');
      var description = root.querySelector('[data-fc-review-description]');
      var prevButton = root.querySelector('[data-fc-review-prev]');
      var nextButton = root.querySelector('[data-fc-review-next]');

      var autoplay = root.dataset.autoplay === 'true' && !prefersReduced();
      var imageDuration = (parseFloat(root.dataset.imageDuration) || 5) * 1000;

      var active = 0;
      var inView = false;
      var userPaused = false;
      var imageTimer = null;
      var imageStart = 0;
      var imageFrame = null;

      var items = cards.map(function (card) {
        return {
          card: card,
          video: card.querySelector('[data-fc-review-video]'),
          progress: card.querySelector('[data-fc-review-progress]'),
          ring: card.querySelector('[data-fc-review-ring]'),
          mute: card.querySelector('[data-fc-review-mute]'),
          title: card.dataset.title || '',
          description: card.dataset.description || '',
        };
      });

      function setProgress(item, ratio) {
        if (!item.progress) return;
        var clamped = Math.max(0, Math.min(1, ratio || 0));
        item.progress.style.strokeDashoffset = CIRCUMFERENCE * (1 - clamped);
      }

      function clearImageTimer() {
        if (imageTimer) {
          clearTimeout(imageTimer);
          imageTimer = null;
        }
        if (imageFrame) {
          cancelAnimationFrame(imageFrame);
          imageFrame = null;
        }
      }

      function updateHeader(item) {
        if (heading && item.title) heading.textContent = item.title;
        else if (heading) heading.textContent = heading.dataset.default || heading.textContent;

        if (description && item.description) description.textContent = item.description;
        else if (description) description.textContent = description.dataset.default || description.textContent;
      }

      function setRingState(item, playing) {
        if (!item.ring) return;
        item.ring.setAttribute('aria-pressed', playing ? 'true' : 'false');
        var label = playing ? item.ring.dataset.labelPause : item.ring.dataset.labelPlay;
        if (label) item.ring.setAttribute('aria-label', label);
      }

      function setMuteState(item, unmuted) {
        if (!item.mute) return;
        item.mute.setAttribute('aria-pressed', unmuted ? 'true' : 'false');
        item.mute.setAttribute('aria-label', unmuted ? 'Mute video' : 'Unmute video');
      }

      function stop(item) {
        item.card.classList.remove('is-playing');
        item.card.classList.remove('is-unmuted');
        setRingState(item, false);
        setMuteState(item, false);
        if (item.video) {
          item.video.pause();
          item.video.muted = true;
          try {
            item.video.currentTime = 0;
          } catch (error) {
            /* Some browsers throw before metadata loads — safe to ignore */
          }
        }
        setProgress(item, 0);
      }

      function next() {
        activate((active + 1) % items.length, false);
      }

      /* Image-only cards hold their turn for the configured duration */
      function runImageTimer(item) {
        imageStart = Date.now();

        var tick = function () {
          var ratio = (Date.now() - imageStart) / imageDuration;
          setProgress(item, ratio);
          if (ratio < 1) imageFrame = requestAnimationFrame(tick);
        };
        imageFrame = requestAnimationFrame(tick);

        imageTimer = setTimeout(function () {
          clearImageTimer();
          next();
        }, imageDuration);
      }

      /* `withSound` is only ever true off the back of a click — the chain plays muted */
      function playActive(withSound) {
        var item = items[active];
        if (!item) return;

        item.card.classList.add('is-playing');
        item.card.classList.toggle('is-unmuted', withSound === true);
        setRingState(item, true);
        setMuteState(item, withSound === true);

        if (item.video) {
          item.video.muted = withSound !== true;

          var attempt = item.video.play();
          if (attempt && typeof attempt.catch === 'function') {
            attempt.catch(function () {
              /* A browser that refuses sound still gets to play the clip muted */
              if (withSound === true && !item.video.muted) {
                item.video.muted = true;
                item.card.classList.remove('is-unmuted');
                setMuteState(item, false);
                item.video.play().catch(function () {
                  item.card.classList.remove('is-playing');
                  setRingState(item, false);
                });
                return;
              }
              item.card.classList.remove('is-playing');
              item.card.classList.remove('is-unmuted');
              setRingState(item, false);
              setMuteState(item, false);
            });
          }
          return;
        }

        clearImageTimer();
        runImageTimer(item);
      }

      /*
        Click once to hear the review, click again to stop it. The second click
        both pauses and mutes, so nothing keeps playing off screen.
      */
      function toggleCard(index) {
        var item = items[index];
        if (!item) return;

        var video = item.video;
        var isCurrent = index === active;

        if (isCurrent && video && !video.paused && !video.muted) {
          userPaused = true;
          video.pause();
          video.muted = true;
          item.card.classList.remove('is-playing');
          item.card.classList.remove('is-unmuted');
          setRingState(item, false);
          setMuteState(item, false);
          return;
        }

        userPaused = false;

        if (!isCurrent) {
          activate(index, true, true);
          return;
        }

        clearImageTimer();
        playActive(true);
      }

      function scrollIntoView(item) {
        /* subtract the track's own gutter so the card lands inset from the
           edge (matching the scroll-padding the snap uses), not flush */
        var pad = parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
        var offset = item.card.offsetLeft - track.offsetLeft - pad;
        var max = track.scrollWidth - track.clientWidth;
        track.scrollLeft = Math.max(0, Math.min(max, offset));
      }

      function activate(index, fromUser, withSound) {
        if (!items[index]) return;

        clearImageTimer();
        items.forEach(function (item, i) {
          if (i !== index) stop(item);
        });

        active = index;
        if (fromUser) userPaused = false;

        var item = items[active];

        updateHeader(item);
        scrollIntoView(item);
        syncArrows();

        if (fromUser || (autoplay && inView && !userPaused)) playActive(withSound);
      }

      function syncArrows() {
        if (prevButton) prevButton.disabled = active === 0;
        if (nextButton) nextButton.disabled = active === items.length - 1;
      }

      items.forEach(function (item, index) {
        if (item.video) {
          item.video.muted = true;

          item.video.addEventListener('timeupdate', function () {
            if (index !== active || !item.video.duration) return;
            setProgress(item, item.video.currentTime / item.video.duration);
          });

          item.video.addEventListener('ended', function () {
            if (index !== active) return;
            setProgress(item, 1);
            next();
          });
        }

        if (item.mute) {
          item.mute.addEventListener('click', function (event) {
            event.stopPropagation();
            var video = item.video;
            if (!video) return;

            /* unmuted and playing → just mute, keep playing */
            if (!video.muted && !video.paused) {
              video.muted = true;
              item.card.classList.remove('is-unmuted');
              setMuteState(item, false);
              return;
            }

            /* muted → unmute; a card that isn't playing starts with sound */
            userPaused = false;
            if (index !== active || video.paused) {
              activate(index, true, true);
              return;
            }
            video.muted = false;
            item.card.classList.add('is-unmuted');
            setMuteState(item, true);
          });
        }

        item.card.addEventListener('click', function (event) {
          /* The ring runs the same toggle — let it handle its own clicks */
          if (item.ring && item.ring.contains(event.target)) return;
          if (item.mute && item.mute.contains(event.target)) return;
          toggleCard(index);
        });

        /* The ring is the keyboard-reachable version of the card click */
        if (item.ring) {
          item.ring.addEventListener('click', function () {
            toggleCard(index);
          });
        }
      });

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          activate(Math.max(0, active - 1), true);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          activate(Math.min(items.length - 1, active + 1), true);
        });
      }

      /* Keep the active card in step when the shopper scrolls the track by hand */
      var scrollTimer = null;
      track.addEventListener('scroll', function () {
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var nearest = 0;
          var smallest = Infinity;
          items.forEach(function (item, i) {
            var distance = Math.abs(item.card.offsetLeft - track.offsetLeft - track.scrollLeft);
            if (distance < smallest) {
              smallest = distance;
              nearest = i;
            }
          });
          if (nearest !== active) activate(nearest, false);
        }, 120);
      });

      if ('IntersectionObserver' in window) {
        var viewObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              inView = entry.isIntersecting;
              if (inView) {
                if (autoplay && !userPaused) playActive();
              } else {
                clearImageTimer();
                /* Scrolling away always kills the sound as well as the picture */
                stop(items[active]);
              }
            });
          },
          { threshold: 0.3 }
        );
        viewObserver.observe(root);
      } else if (autoplay) {
        playActive();
      }

      updateHeader(items[0]);
      syncArrows();
    }

    function initFcReviewCarousel(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var roots = scope.querySelectorAll(ROOT_SELECTOR);

      Array.prototype.forEach.call(roots, function (el) {
        if (el.dataset.fcReviewReady === 'true') return;
        el.dataset.fcReviewReady = 'true';
        setupCarousel(el);
      });
    }

    function init(root) {
      initFcAnim(root);
      initFcReviewCarousel(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-routine-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ANIM_SELECTOR = '[data-fc-anim]';
    var ROOT_SELECTOR = '[data-fc-routine-video]';

    function prefersReduced() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function toArray(list) {
      return Array.prototype.slice.call(list);
    }

    /* Shared Full Cart premium reveal */
    function initFcAnim(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var elements = scope.querySelectorAll(ANIM_SELECTOR);
      if (!elements.length) return;

      var observer = null;
      if (!prefersReduced() && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('fc-anim--in');
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
        );
      }

      Array.prototype.forEach.call(elements, function (el) {
        if (el.dataset.fcAnimReady === 'true') return;
        el.dataset.fcAnimReady = 'true';

        if (!observer) {
          el.classList.add('fc-anim--in');
          return;
        }

        observer.observe(el);
      });
    }

    function setupComponent(root) {
      var card = root.querySelector('[data-fc-routine-card]');
      var videos = toArray(root.querySelectorAll('[data-fc-routine-video-el]'));
      if (!card || !videos.length) return;

      var tabs = toArray(root.querySelectorAll('[data-fc-routine-tab]'));
      var panels = toArray(root.querySelectorAll('.fc-routine-video__panel'));
      var tablist = root.querySelector('[data-fc-routine-tablist]');
      var indicator = root.querySelector('[data-fc-routine-indicator]');
      var playButton = root.querySelector('[data-fc-routine-play]');
      var muteButton = root.querySelector('[data-fc-routine-mute]');
      var autoplay = root.dataset.autoplay === 'true' && !prefersReduced();

      var active = 0;
      var muted = true;
      var userPaused = false;
      var inView = false;

      videos.forEach(function (video) {
        video.muted = true;
      });

      function current() {
        return videos[active];
      }

      /* Slides the active pill to the tab at `index`. */
      function moveIndicator(index, animate) {
        if (!indicator || !tablist || !tabs[index]) return;

        var tab = tabs[index];

        if (!animate) indicator.style.transition = 'none';

        indicator.style.width = tab.offsetWidth + 'px';
        indicator.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
        tablist.classList.add('has-indicator');

        if (!animate) {
          /* Force a reflow so the jump is not animated, then restore the transition */
          void indicator.offsetWidth;
          indicator.style.transition = '';
        }
      }

      function syncPlayButton() {
        if (!playButton) return;
        var video = current();
        var playing = !video.paused && !video.ended;
        playButton.setAttribute('aria-pressed', playing ? 'true' : 'false');
        playButton.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      }

      function play() {
        var attempt = current().play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(function () {
            card.classList.remove('is-playing');
            syncPlayButton();
          });
        }
      }

      videos.forEach(function (video, index) {
        ['playing', 'pause', 'ended'].forEach(function (name) {
          video.addEventListener(name, function () {
            if (index !== active) return;
            card.classList.toggle('is-playing', name === 'playing');
            syncPlayButton();
          });
        });
      });

      function activate(index, moveFocus) {
        if (index === active || !videos[index]) return;

        var previous = current();
        var wasPlaying = !previous.paused && !previous.ended;
        previous.pause();
        try {
          previous.currentTime = 0;
        } catch (error) {
          /* Some browsers throw before metadata loads — safe to ignore */
        }

        active = index;

        panels.forEach(function (panel, i) {
          panel.hidden = i !== index;
        });

        tabs.forEach(function (tab, i) {
          var selected = i === index;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
        });

        moveIndicator(index, true);

        current().muted = muted;

        if (moveFocus && tabs[index]) tabs[index].focus();

        if (wasPlaying || (autoplay && inView && !userPaused)) {
          play();
        } else {
          card.classList.remove('is-playing');
          syncPlayButton();
        }
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activate(index, false);
        });

        tab.addEventListener('keydown', function (event) {
          var last = tabs.length - 1;
          var next = null;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            next = index === last ? 0 : index + 1;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            next = index === 0 ? last : index - 1;
          } else if (event.key === 'Home') {
            next = 0;
          } else if (event.key === 'End') {
            next = last;
          }

          if (next === null) return;
          event.preventDefault();
          activate(next, true);
        });
      });

      if (playButton) {
        playButton.addEventListener('click', function () {
          var video = current();
          if (video.paused || video.ended) {
            userPaused = false;
            play();
          } else {
            userPaused = true;
            video.pause();
          }
        });
      }

      if (muteButton) {
        muteButton.addEventListener('click', function () {
          muted = !muted;
          videos.forEach(function (video) {
            video.muted = muted;
          });
          card.classList.toggle('is-unmuted', !muted);
          muteButton.setAttribute('aria-pressed', muted ? 'true' : 'false');
          muteButton.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
        });
      }

      if (autoplay && 'IntersectionObserver' in window) {
        var viewObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              inView = entry.isIntersecting;
              if (inView) {
                if (!userPaused) play();
              } else if (!current().paused) {
                current().pause();
              }
            });
          },
          { threshold: 0.5 }
        );
        viewObserver.observe(card);
      }

      if (indicator && tabs.length) {
        moveIndicator(active, false);

        /* Tab widths change with the breakpoint, the font swap and editor edits */
        var reposition = function () {
          moveIndicator(active, false);
        };

        if ('ResizeObserver' in window) {
          new ResizeObserver(reposition).observe(tablist);
        } else {
          window.addEventListener('resize', reposition);
        }

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(reposition);
        }
      }

      syncPlayButton();
    }

    function initFcRoutineVideo(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var roots = scope.querySelectorAll(ROOT_SELECTOR);

      Array.prototype.forEach.call(roots, function (el) {
        if (el.dataset.fcRoutineReady === 'true') return;
        el.dataset.fcRoutineReady = 'true';
        setupComponent(el);
      });
    }

    function init(root) {
      initFcAnim(root);
      initFcRoutineVideo(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-science"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ANIM_SELECTOR = '[data-fc-anim]';
    var ROOT_SELECTOR = '[data-fc-science]';
    var DESKTOP_QUERY = '(min-width: 1024px)';

    function prefersReduced() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function toArray(list) {
      return Array.prototype.slice.call(list);
    }

    /* Shared Full Cart premium reveal */
    function initFcAnim(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var elements = scope.querySelectorAll(ANIM_SELECTOR);
      if (!elements.length) return;

      var observer = null;
      if (!prefersReduced() && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('fc-anim--in');
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
        );
      }

      Array.prototype.forEach.call(elements, function (el) {
        if (el.dataset.fcAnimReady === 'true') return;
        el.dataset.fcAnimReady = 'true';

        if (!observer) {
          el.classList.add('fc-anim--in');
          return;
        }

        observer.observe(el);
      });
    }

    function setupComponent(root) {
      var items = toArray(root.querySelectorAll('[data-fc-science-item]'));
      var tabs = toArray(root.querySelectorAll('[data-fc-science-tab]'));
      var groups = toArray(root.querySelectorAll('[data-fc-science-group]'));
      var tablist = root.querySelector('[data-fc-science-tablist]');
      var indicator = root.querySelector('[data-fc-science-indicator]');

      var desktop = window.matchMedia ? window.matchMedia(DESKTOP_QUERY) : null;
      var active = 0;
      var wasDesktop = false;
      var openFirst = root.dataset.openFirst === 'true';

      /* --- Collapsible cards (mobile only — desktop keeps every card open) --- */
      function isDesktop() {
        return desktop ? desktop.matches : false;
      }

      function setOpen(item, isOpen) {
        var toggle = item.querySelector('[data-fc-science-toggle]');
        if (!toggle || toggle.disabled) return;

        item.classList.toggle('is-open', isOpen);
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }

      /* On desktop the layout forces every panel open, so the control is inert */
      function syncToggles() {
        var onDesktop = isDesktop();

        groups.forEach(function (group) {
          var groupItems = toArray(group.querySelectorAll('[data-fc-science-item]'));

          groupItems.forEach(function (item, index) {
            var toggle = item.querySelector('[data-fc-science-toggle]');
            if (!toggle || toggle.disabled) return;

            if (onDesktop) {
              toggle.setAttribute('aria-disabled', 'true');
              toggle.setAttribute('aria-expanded', 'true');
              item.classList.add('is-open');
              return;
            }

            toggle.removeAttribute('aria-disabled');

            /* Coming back from desktop every card is open — collapse to the Figma mobile state */
            if (wasDesktop) {
              setOpen(item, openFirst && index === 0);
            } else {
              setOpen(item, item.classList.contains('is-open'));
            }
          });
        });

        wasDesktop = onDesktop;
      }

      items.forEach(function (item) {
        var toggle = item.querySelector('[data-fc-science-toggle]');
        if (!toggle || toggle.disabled) return;

        toggle.addEventListener('click', function () {
          if (isDesktop()) return;

          var willOpen = !item.classList.contains('is-open');
          var siblings = toArray(item.parentNode.querySelectorAll('[data-fc-science-item]'));

          /* One card open at a time within a group, matching the Figma mobile frame */
          siblings.forEach(function (other) {
            setOpen(other, willOpen && other === item);
          });
        });
      });

      syncToggles();

      if (desktop) {
        var onChange = function () {
          syncToggles();
          moveIndicator(active, false);
        };
        if (typeof desktop.addEventListener === 'function') {
          desktop.addEventListener('change', onChange);
        } else if (typeof desktop.addListener === 'function') {
          desktop.addListener(onChange);
        }
      }

      /* --- Product tabs --- */
      if (!tabs.length || !groups.length) return;

      /* Slides the active pill to the tab at `index`. */
      function moveIndicator(index, animate) {
        if (!indicator || !tablist || !tabs[index]) return;

        var tab = tabs[index];

        if (!animate) indicator.style.transition = 'none';

        indicator.style.width = tab.offsetWidth + 'px';
        indicator.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
        tablist.classList.add('has-indicator');

        if (!animate) {
          /* Force a reflow so the jump is not animated, then restore the transition */
          void indicator.offsetWidth;
          indicator.style.transition = '';
        }
      }

      function activate(index, moveFocus) {
        if (index === active || !groups[index]) return;

        var direction = index > active ? 'is-entering-next' : 'is-entering-prev';
        active = index;

        groups.forEach(function (group, i) {
          group.classList.remove('is-entering-next', 'is-entering-prev');
          group.hidden = i !== index;
        });

        /* Restart the slide-in on the incoming group */
        void groups[index].offsetWidth;
        groups[index].classList.add(direction);

        tabs.forEach(function (tab, i) {
          var selected = i === index;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
        });

        moveIndicator(index, true);
        syncToggles();

        if (moveFocus && tabs[index]) tabs[index].focus();
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activate(index, false);
        });

        tab.addEventListener('keydown', function (event) {
          var last = tabs.length - 1;
          var next = null;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            next = index === last ? 0 : index + 1;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            next = index === 0 ? last : index - 1;
          } else if (event.key === 'Home') {
            next = 0;
          } else if (event.key === 'End') {
            next = last;
          }

          if (next === null) return;
          event.preventDefault();
          activate(next, true);
        });
      });

      groups.forEach(function (group) {
        group.addEventListener('animationend', function () {
          group.classList.remove('is-entering-next', 'is-entering-prev');
        });
      });

      /* The pill needs a laid-out tab to measure, so place it after paint */
      if ('requestAnimationFrame' in window) {
        window.requestAnimationFrame(function () {
          moveIndicator(active, false);
        });
      } else {
        moveIndicator(active, false);
      }

      window.addEventListener('resize', function () {
        moveIndicator(active, false);
      });
    }

    function initFcScience(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var roots = scope.querySelectorAll(ROOT_SELECTOR);

      Array.prototype.forEach.call(roots, function (el) {
        if (el.dataset.fcScienceReady === 'true') return;
        el.dataset.fcScienceReady = 'true';
        setupComponent(el);
      });
    }

    function init(root) {
      initFcAnim(root);
      initFcScience(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-simpletics-collapsible"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ANIM_SELECTOR = '[data-fc-anim]';
    var ROOT_SELECTOR = '[data-fc-simpc]';

    function prefersReduced() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function toArray(list) {
      return Array.prototype.slice.call(list);
    }

    /* Shared Full Cart premium reveal */
    function initFcAnim(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var elements = scope.querySelectorAll(ANIM_SELECTOR);
      if (!elements.length) return;

      var observer = null;
      if (!prefersReduced() && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('fc-anim--in');
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
        );
      }

      Array.prototype.forEach.call(elements, function (el) {
        if (el.dataset.fcAnimReady === 'true') return;
        el.dataset.fcAnimReady = 'true';

        if (!observer) {
          el.classList.add('fc-anim--in');
          return;
        }

        observer.observe(el);
      });
    }

    function setupComponent(root) {
      var items = toArray(root.querySelectorAll('[data-fc-simpc-item]'));
      if (!items.length) return;

      var media = toArray(root.querySelectorAll('[data-fc-simpc-media]'));
      var maxHeight = parseInt(root.dataset.textMax, 10);
      var moreLabel = root.dataset.readMore || 'Read more';
      var lessLabel = root.dataset.readLess || 'Read less';

      if (!maxHeight || maxHeight < 1) maxHeight = 300;

      function setLabel(button, label) {
        var span = button.querySelector('[data-fc-simpc-readmore-label]');
        if (span) span.textContent = label;
      }

      /* Read more / read less — the description clamps at the configured max height */
      function collapseText(item) {
        var text = item.querySelector('[data-fc-simpc-text]');
        var button = item.querySelector('[data-fc-simpc-readmore]');
        if (!text || !button || button.hidden) return;
        if (!item.classList.contains('is-expanded')) return;

        text.style.maxHeight = text.scrollHeight + 'px';
        /* Force a reflow so the browser has a start value to transition from */
        void text.offsetHeight;
        text.style.maxHeight = maxHeight + 'px';

        item.classList.remove('is-expanded');
        button.setAttribute('aria-expanded', 'false');
        setLabel(button, moreLabel);
      }

      function expandText(item) {
        var text = item.querySelector('[data-fc-simpc-text]');
        var button = item.querySelector('[data-fc-simpc-readmore]');
        if (!text || !button) return;

        text.style.maxHeight = text.scrollHeight + 'px';
        item.classList.add('is-expanded');
        button.setAttribute('aria-expanded', 'true');
        setLabel(button, lessLabel);
      }

      /* Re-run after the web font swaps, which changes how tall the copy is */
      var measurers = [];

      function setupReadMore(item) {
        var text = item.querySelector('[data-fc-simpc-text]');
        var button = item.querySelector('[data-fc-simpc-readmore]');
        if (!text || !button) return;

        /* scrollHeight is the full copy height whether or not the clamp is applied */
        function measure() {
          if (item.classList.contains('is-expanded')) return;

          if (text.scrollHeight <= maxHeight + 1) {
            button.hidden = true;
            text.classList.add('is-unclamped');
            text.style.maxHeight = '';
            return;
          }

          button.hidden = false;
          text.classList.remove('is-unclamped');
          text.style.maxHeight = maxHeight + 'px';
        }

        /* Drop the fixed height once expanded so later reflows are never clipped */
        text.addEventListener('transitionend', function (event) {
          if (event.propertyName !== 'max-height') return;
          if (item.classList.contains('is-expanded')) text.style.maxHeight = 'none';
        });

        button.addEventListener('click', function () {
          if (item.classList.contains('is-expanded')) {
            collapseText(item);
          } else {
            expandText(item);
          }
        });

        measurers.push(measure);
        measure();
      }

      /* Only one row is open at a time — the open row closes before the next opens */
      function setOpen(index, isOpen) {
        var item = items[index];
        if (!item) return;

        var toggle = item.querySelector('[data-fc-simpc-toggle]');
        item.classList.toggle('is-open', isOpen);
        if (toggle) toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        if (!isOpen) collapseText(item);
      }

      function showMedia(index) {
        media.forEach(function (el) {
          var active = parseInt(el.dataset.fcSimpcMedia, 10) === index;
          el.classList.toggle('is-active', active);
          if (active) {
            el.removeAttribute('aria-hidden');
          } else {
            el.setAttribute('aria-hidden', 'true');
          }
        });
      }

      function activate(index) {
        items.forEach(function (item, i) {
          setOpen(i, i === index);
        });
        showMedia(index);
      }

      items.forEach(function (item, index) {
        setupReadMore(item);

        var toggle = item.querySelector('[data-fc-simpc-toggle]');
        if (!toggle) return;

        toggle.addEventListener('click', function () {
          if (item.classList.contains('is-open')) {
            setOpen(index, false);
          } else {
            activate(index);
          }
        });
      });

      /* Keep the image in sync with whichever row rendered open */
      var initial = -1;
      items.forEach(function (item, index) {
        if (initial === -1 && item.classList.contains('is-open')) initial = index;
      });
      showMedia(initial > -1 ? initial : 0);

      function remeasure() {
        measurers.forEach(function (measure) {
          measure();
        });
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(remeasure);
      }

      /* Column width changes with the breakpoint, which changes how tall the copy is */
      var resizeTimer = null;
      var lastWidth = window.innerWidth;
      window.addEventListener('resize', function () {
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(remeasure, 150);
      });
    }

    function initFcSimpleticsCollapsible(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var roots = scope.querySelectorAll(ROOT_SELECTOR);

      Array.prototype.forEach.call(roots, function (el) {
        if (el.dataset.fcSimpcReady === 'true') return;
        el.dataset.fcSimpcReady = 'true';
        setupComponent(el);
      });
    }

    function init(root) {
      initFcAnim(root);
      initFcSimpleticsCollapsible(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-styling-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ANIM_SELECTOR = '[data-fc-anim]';
    var ROOT_SELECTOR = '[data-fc-styling-carousel]';
    var MIN_GROUPS = 2;

    function prefersReduced() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function toArray(list) {
      return Array.prototype.slice.call(list);
    }

    /* Shared Full Cart premium reveal */
    function initFcAnim(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var elements = scope.querySelectorAll(ANIM_SELECTOR);
      if (!elements.length) return;

      var observer = null;
      if (!prefersReduced() && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('fc-anim--in');
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
        );
      }

      Array.prototype.forEach.call(elements, function (el) {
        if (el.dataset.fcAnimReady === 'true') return;
        el.dataset.fcAnimReady = 'true';

        if (!observer) {
          el.classList.add('fc-anim--in');
          return;
        }

        observer.observe(el);
      });
    }

    /*
      The track holds identical groups of slides. We clone enough of them to
      cover the viewport twice, then translate the track by exactly one group
      (plus the flex gap) so the loop is seamless whatever the slide count is.
    */
    function layoutMarquee(marquee, speed) {
      var track = marquee.querySelector('[data-fc-styling-track]');
      if (!track) return;

      var groups = toArray(track.querySelectorAll('[data-fc-styling-group]'));
      if (groups.length < MIN_GROUPS) return;

      /* Drop clones from a previous pass so a resize recomputes from scratch */
      toArray(track.querySelectorAll('[data-fc-styling-clone]')).forEach(function (clone) {
        track.removeChild(clone);
      });

      var source = groups[1] || groups[0];
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      var groupWidth = source.getBoundingClientRect().width;

      if (!groupWidth) return;

      var shift = groupWidth + gap;
      var visible = marquee.offsetWidth || 0;
      var needed = Math.max(MIN_GROUPS, Math.ceil((visible + shift + gap) / shift));

      for (var i = track.children.length; i < needed; i++) {
        var clone = source.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-fc-styling-clone', '');
        track.appendChild(clone);
      }

      track.style.setProperty('--fc-styling-shift', shift + 'px');
      track.style.setProperty('--fc-styling-duration', shift / speed + 's');
      track.setAttribute('data-ready', 'true');
    }

    function setupComponent(root) {
      var speed = parseFloat(root.dataset.speed);
      if (!speed || speed <= 0) speed = 40;

      var marquees = toArray(root.querySelectorAll('[data-fc-styling-marquee]'));
      if (!marquees.length) return;

      function layoutAll() {
        marquees.forEach(function (marquee) {
          layoutMarquee(marquee, speed);
        });
      }

      layoutAll();

      /* Images change the group width once they land */
      toArray(root.querySelectorAll('img')).forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', layoutAll, { once: true });
      });

      var lastWidth = window.innerWidth;
      var resizeTimer = null;

      function onResize() {
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;

        if (resizeTimer) window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(layoutAll, 200);
      }

      window.addEventListener('resize', onResize);
      window.addEventListener('orientationchange', onResize);
    }

    function init(scope) {
      var root = scope && scope.querySelector ? scope : document;
      toArray(root.querySelectorAll(ROOT_SELECTOR)).forEach(function (el) {
        if (el.dataset.fcStylingReady === 'true') return;
        el.dataset.fcStylingReady = 'true';
        setupComponent(el);
      });

      initFcAnim(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    document.addEventListener('shopify:section:select', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
